import { apiClient, type UnkoudateContractExEntity } from '@/libs/api'

export type FetchUnkoudateContractQuery = {
  tenantKey: string
  contractId: number
}

export const fetchUnkoudateContract = async (
  { tenantKey, contractId }: FetchUnkoudateContractQuery,
  signal?: AbortSignal
): Promise<UnkoudateContractExEntity> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .unkoudate_contracts._id(contractId)
    .$get({ config: { signal } })
  return data
}
